module.exports = __webpack_public_path__ + "img/monarch-ui-icon_VARIANT.f43f1046.png";